<template>
  <div class="apj-player">
    <el-dialog
      title=""
      width="1000px"
      class="video-container"
      :visible.sync="visible"
      :append-to-body="true"
    >
      <video-player
        class="video-player vjs-custom-skin"
        ref="playerRef"
        :playsinline="true"
        :options="playerOptions"
      >
      </video-player>
    </el-dialog>
  </div>
</template>

<script>
import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";
export default {
  name: "apj-player",
  props: {
    data: {
      type: String,
      default: "https://static.sxbang.net/apj/apj-ad-mainland.mp4",
    },
    // visible: {
    //   type: Boolean,
    //   default: false,
    // },
  },
  components: {
    videoPlayer,
  },
  data() {
    return {
      videoType: {
        mp4: "video/mp4",
      },
      visible: false,
      // playerOptions: {

      // },
      events: []
    };
  },
  computed: {
    // videoVisible() {
    //   return this.visible || this.visibleFlag;
    // },
    playerOptions() {
      return {
        height: 700,
        playbackRates: [1.0, 1.5], // 可选的播放速度
        autoplay: false, // 如果为true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: true, // 是否视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4", // 类型
            // src: "https://static.sxbang.net/apj/apj-ad-mainland.mp4", // url地址
            src: this.data,
          },
        ],
        poster: '', // 封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        // controls: false,
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: false, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          fullscreenToggle: true, // 是否显示全屏按钮
        },
      };
    },
  },
  watch: {
    visible(val) {
      if (!val) {
        // console.log('visible == false', val, this.visible);
        this.$nextTick(function () {
          this.$refs.playerRef.player.pause();
        });
      }
    },
  },
  methods: {
    show() {
      this.visible = true;
    },
    play() {
      this.show();
      // this.$refs['playerRef'].src(this.data);
      // this.$refs['playerRef'].play();
      this.$nextTick(function () {
        // console.log('.$nextTick( /// ');
        this.$refs["playerRef"].player.src(this.data);
        this.$refs.playerRef.player.play();
      });
    },
  },
};
</script>


<style lang="scss" scoped>
// @import url("https://at.alicdn.com/t/font_2425752_agu6ou9vlug.css");
// @import "@/assets/theme.scss";

/**  replace element css */
::v-deep .el-dialog {
  background-color: transparent;
  box-shadow: unset;
  margin-top: 8vh !important;
}
/** apj-page-contact */
</style>



// WEBPACK FOOTER //
// src/components/apj-player/index.vue